"use client";

import React, { Fragment, ReactNode } from "react";

import { useSelectedLayoutSegments } from "next/navigation";

interface ResetOnNavigateProps {
  children: ReactNode;
}

/*
 * Cache Components keeps previous routes mounted (hidden with <Activity>), so a page can come back
 * with its old React state: open modals, slides, form entries. We want every page to load pristine,
 * as if opened for the first time, on any navigation (link, menu, back, forward). Keying the page
 * subtree on the rendered route remounts it on every route change.
 *
 * Key on the route segments, not usePathname(): Next syncs usePathname() with raw
 * history.pushState/replaceState, which pages like the quiz use to update the URL in place.
 */
export default function ResetOnNavigate({ children }: ResetOnNavigateProps) {
  const segments = useSelectedLayoutSegments();

  return <Fragment key={segments.join("/")}>{children}</Fragment>;
}
